import gql from 'graphql-tag';

export default gql`
query getGroupPlanUsage($groupId: Int!) {
  groups_by_pk(group_id: $groupId) {
    group_id
    plan_id
    limits_override
    plan {
      plan_id
      handle
      name
      limit_projects
      limit_pages_per_project
      limit_users
      features
    }
  }
  projects_aggregate(where: { group_id: { _eq: $groupId } }) {
    aggregate { count }
  }
  users_roles_groups_aggregate(where: { group_id: { _eq: $groupId } }) {
    aggregate { count }
  }
}
`;
